export default __webpack_public_path__ + "static/images/plugin-seo.png?9359f3638e2c47c5601d997ada22680b";